<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ViewHistory')"
    width="730px"
    :close-on-click-modal="false"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>gridApi=params.api"
    />

    <!-- 日志弹出窗 -->
    <task-log-detail-dialog
      v-if="errorLogDialog.visible"
      :visible.sync="errorLogDialog.visible"
      :row-data="errorLogDialog.rowData"
      @close="errorLogDialog.visible= false"
    />
  </el-dialog>
</template>

<script>

import { taskLogFunc } from '@/api/sysAutoConfig/sysAutoConfig'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { DocumentManage } from '@/utils/commonUtil'
import taskLogDetailDialog
  from '@/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/component/taskLogDetailDialog.vue'

export default {
  name: 'TaskLogDialog',
  components: { taskLogDetailDialog },
  props: {
    visible: { type: Boolean, required: true },
    form: { type: Object, required: false, default: () => {} }
  },
  data() {
    return {
      innerVisible: false,
      documentManage: new DocumentManage(),
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_TaskScenario'),
          field: 'taskScenario',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.TASK_SCENARIO_LIST)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ExecutionTime'),
          field: 'dateCreated',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_HandleResult'),
          field: 'dateCreated',
          width: 300,
          valueFormatter: (params) => {
            return this.$t('CargoMsg.Cargo_Success') + ':' + params.data.successNum + this.$t('CargoMsg.Cargo_Pcst') + '/' + this.$t('Message.Failure') + ':' + params.data.failNum + this.$t('CargoMsg.Cargo_Pcst')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OrderOperation'),
          field: 'dateCreated',
          width: 100,
          cellRenderer: params => {
            const onOperation = this.documentManage.getPath('onOperation')
            return `<div onclick="${onOperation}('${params.data.batchNo}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_Details')}</div>`
          }
        }
      ],
      rowData: [],
      gridApi: null,
      errorLogDialog: {
        visible: false,
        rowData: []
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onOperation', function(value) {
      context.onOperation(value)
    })
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.searchHandle()
    } else {
      this.rowData = []
    }
  },
  methods: {
    searchHandle() {
      if (!this.form.uuid) {
        return
      }
      taskLogFunc({ uuid: this.form.uuid }).then(res => {
        this.rowData = res.data
      })
    },
    async onOperation(batchNo) {
      const data = this.rowData.filter(row => row.batchNo === batchNo)
      if (data && data.length > 0) {
        taskLogFunc({ uuid: this.form.uuid, anyStr: batchNo }).then(res => {
          this.errorLogDialog.visible = true
          this.errorLogDialog.rowData = res.data
        })
      }
    }
  }
}
</script>
